import { IApps } from "../../../../models/master/apps";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { useNavigate } from "react-router-dom";
import { IFinanceResource } from "../../../../models/dashboard/staffDashboard";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { getApps } from "../../../../action/masters/appActionCreator";
import { setApps } from "../../../../store/slices/master/appSlice";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const FinanceResources = (props: IFinanceResource) => {
  const { getFinanceResources, financeResources, snapShots } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.financeResources);

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_FINANCE_RESOURCES);
  };

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getFinanceResources(pageBlockId.financeResources, limit.four);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    };
  }, []);

  return (
    <>
      <div
       className={
        pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
      }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Finance Resources</h2>
          <a
            onClick={handleViewALL}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Resources"
          >
            View All
          </a>
        </div>
        <div className="row financeresources">
          {financeResources
            ?.filter((finance: IApps) => finance.displayOrNot)
            .map((finance: IApps) => (
              <div className="col-lg-12" key={finance.id}>
                <div className="btncard icon-visibility">
                  <a href={finance.url} target="_blank">
                    <img src={baseURL + finance.image} alt="" />
                    <h3>{finance.name}</h3>
                    <span>
                      <img src="/assets/images/icon/arrow-right.svg" alt="" />
                    </span>
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getFinanceResources: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    financeResources: state.app.appsForTerm,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinanceResources);
